module.exports = __webpack_public_path__ + "static/media/ico-menu-02.5bbc33fb.svg";